export default __webpack_public_path__ + "static/header@2x-b005d59df2250bdcca2215bb9cccdcc6.jpg";